import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  mainMenuToggle: boolean = false;

  constructor(private router: Router) {}
}
